import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

const SOS = React.lazy(() => import("./sos"));
const SOSList = React.lazy(() => import("./sos-list"));
export const sosPublicRouteConfig = [
    {
        path: "/sos/:shortId",
        element: <SOS />,
    },
];
export const SosConfigs = [
    {
        path: "/sos/sos-list",
        element: <SOSList />,
        permittedRole: [RoutePermittedRole.ADMIN, RoutePermittedRole.SUPER_ADMIN, RoutePermittedRole.HR_MANAGER],
    },
];
